import type { SVGProps } from 'react';

interface PescatarianIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
  color?: string;
}

export function PescatarianIcon({ className, color = '#6FB0E5', ...props }: PescatarianIconProps) {
  return (
    <svg
      width="21"
      height="17"
      viewBox="0 0 21 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path
        d="M19.3811 10.1716C19.2092 9.24489 19.1718 8.60417 19.3133 7.66654C19.4922 6.47786 19.8951 5.33394 20.2312 4.19438C18.6893 4.67356 17.2456 5.51186 15.8472 6.36435C15.2261 5.58172 14.494 4.89951 13.7029 4.33519C13.4189 4.13326 12.6808 3.77632 12.5373 3.50563C12.2347 2.93803 12.2828 2.0779 12.5216 1.48957L12.9717 0.655638C11.0564 0.153534 9.41126 0.913239 7.96762 2.26019C7.81824 2.3999 7.62169 2.70772 7.47428 2.80159C7.26004 2.93803 6.72642 3.02535 6.45027 3.1345C4.61451 3.86256 2.54585 5.69633 1.40391 7.44169C1.23586 7.6971 0.738598 8.52448 0.722874 8.80064C0.69634 9.2962 1.82059 10.808 2.15374 11.2162C3.44604 12.7978 5.40365 14.3642 7.28854 14.8805C7.58533 14.9623 8.2477 15.0104 8.45604 15.1086C8.5435 15.1501 8.80687 15.519 8.92382 15.6238C9.70804 16.3257 10.6898 16.64 11.6942 16.4414C11.6637 16.2154 11.4839 16.0681 11.4101 15.8585C11.304 15.5561 11.2775 15.2265 11.3757 14.9176C11.4917 14.5563 11.7973 14.6021 12.0981 14.4679C13.5938 13.7999 14.9382 12.8579 15.9956 11.4945C16.1234 11.4585 16.3415 11.6954 16.4673 11.7685C17.6918 12.4846 18.9497 13.1569 20.2774 13.6099C19.9511 12.4966 19.5914 11.3188 19.3792 10.1705L19.3811 10.1716ZM5.4862 9.30493C3.66421 9.57126 3.48338 6.56082 5.21202 6.49205C6.82174 6.42765 6.97014 9.08771 5.4862 9.30493Z"
        fill={color}
      />
    </svg>
  );
}
